import React, { useState, useEffect, useCallback } from "react";
import { DataGrid } from "@mui/x-data-grid";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import { getUserInvestmentDetails } from "../../redux/actions/adminActions";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import Close from "../../assets/images/close-icon.png";
import Loader from "../../components/Loader/Loader";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "../../components/common/css/datatable.scss";

const DesignationReportDetails = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [reportDetailsLevel, setReportDetailsLevel] = useState(false);
  const params = useParams();
  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 9,
  });
  const [refferalData, setRefferalData] = useState([]);

  const userManagerColumns = [
    { field: "id", headerName: "ID", width: 60 },

    {
      field: "firstname",
      headerName: "User Name",
      width: 200,
      renderCell: (params) => {
        const userFullName =
          params?.row?.firstname.charAt(0).toUpperCase() +
          params?.row?.firstname.slice(1) +
          " " +
          params?.row?.lastname.charAt(0).toUpperCase() +
          params?.row?.lastname.slice(1);
        return (
          <>
            <div className="rowitem">{userFullName}</div>
          </>
        );
      },
    },
    {
      field: "country_name",
      headerName: "Country",
      width: 150,
    },
    {
      field: "designation",
      headerName: "Designation",
      width: 150,
    },
    {
      field: "managerFirstname",
      headerName: "Reporting",
      width: 150,
    },
    {
      field: "createdAt",
      headerName: "Joined At",
      width: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.createdAt);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
    {
      field: "updatedAt",
      headerName: "Last Updated",
      width: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.updatedAt);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
  ];
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/users/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon />
              </div>
            </Link>
            <div className="designation-editButton">
              <button
                type="button"
                onClick={() => getRefferalList(params?.row?.id)}
              >
                <GroupsOutlinedIcon />
              </button>
            </div>
            <Modal
              open={open}
              onClose={() => setOpen(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className="designation-report-modal"
            >
              <Box className="modal-popup">
                <div className="modal-top text-right">
                  <Button className="closeBtn" onClick={() => setOpen(false)}>
                    <img src={Close} alt="close-icon" />
                  </Button>
                </div>
                <Typography id="modal-modal-description" sx={{ mt: 1 }}>
                  <div className="newContainer">
                    <div>
                      <div className="designation-DetailsTbl-wrapper">
                        <table className="designation-DetailsTbl">
                          <thead>
                            <tr>
                              <th>Id</th>
                              <th>Name</th>
                              <th>Status</th>
                              <th>Date Joined</th>

                              <th>Investment Made</th>
                            </tr>
                          </thead>
                          <tbody>
                            {refferalData.length > 0 ? (
                              refferalData?.map((report, index) => {
                                const d = new Date(report?.createdAt);
                                return (
                                  <tr key={index}>
                                    <td>{report.id}</td>
                                    <td>
                                      {report.firstname
                                        .charAt(0)
                                        .toUpperCase() +
                                        report.firstname.slice(1) +
                                        " " +
                                        report.lastname
                                          .charAt(0)
                                          .toUpperCase() +
                                        report.lastname.slice(1)}
                                    </td>
                                    <td>
                                      {report?.userStatus == 1 ? (
                                        <span className="verfiedStatus">
                                          Verified
                                        </span>
                                      ) : (
                                        <span className="unverifiedStatus">
                                          Unverified
                                        </span>
                                      )}
                                    </td>
                                    <td>{d.toDateString()}</td>

                                    <td>$ {report?.totalInvested}</td>
                                  </tr>
                                );
                              })
                            ) : (
                              <h3>No data found</h3>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </Typography>
              </Box>
            </Modal>
          </div>
        );
      },
    },
  ];

  const userConsultantColumns = [
    { field: "id", headerName: "ID", width: 60 },

    {
      field: "firstname",
      headerName: "User Name",
      width: 200,
      renderCell: (params) => {
        const userFullName =
          // params?.firstname + " " + params?.lastname;
          params?.row?.firstname.charAt(0).toUpperCase() +
          params?.row?.firstname.slice(1) +
          " " +
          params?.row?.lastname.charAt(0).toUpperCase() +
          params?.row?.lastname.slice(1);
        return (
          <>
            <div className="rowitem">{userFullName}</div>
          </>
        );
      },
    },
    {
      field: "country_name",
      headerName: "Country",
      width: 150,
    },
    {
      field: "designation",
      headerName: "Designation",
      width: 150,
    },
    {
      field: "managerFirstname",
      headerName: "Reporting",
      width: 150,
    },
    {
      field: "createdAt",
      headerName: "Joined At",
      width: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.createdAt);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
    {
      field: "updatedAt",
      headerName: "Last Updated",
      width: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.updatedAt);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
  ];

  const userColumns = [
    { field: "id", headerName: "ID", width: 60 },

    {
      field: "firstname",
      headerName: "User Name",
      width: 200,
      renderCell: (params) => {
        const userFullName =
          params?.row?.firstname.charAt(0).toUpperCase() +
          params?.row?.firstname.slice(1) +
          " " +
          params?.row?.lastname.charAt(0).toUpperCase() +
          params?.row?.lastname.slice(1);
        return (
          <>
            <div className="rowitem">{userFullName}</div>
          </>
        );
      },
    },
    {
      field: "country_name",
      headerName: "Country",
      width: 150,
    },
    {
      field: "designation",
      headerName: "Designation",
      width: 150,
    },
    {
      field: "managerFirstname",
      headerName: "Reporting",
      width: 150,
    },
    {
      field: "createdAt",
      headerName: "Joined At",
      width: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.createdAt);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
    {
      field: "updatedAt",
      headerName: "Last Updated",
      width: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.updatedAt);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
  ];

  const requestColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/designation-report/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon
                  onClick={() => viewTeam(params?.row?.id)}
                />
              </div>
            </Link>
            <div className="designation-editButton">
              <button
                type="button"
                onClick={() => getRefferalList(params?.row?.id)}
              >
                <GroupsOutlinedIcon />
              </button>
            </div>
            <Modal
              open={open}
              onClose={() => setOpen(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className="designation-report-modal"
            >
              <Box className="modal-popup">
                <div className="modal-top text-right">
                  <Button className="closeBtn" onClick={() => setOpen(false)}>
                    <img src={Close} alt="close-icon" />
                  </Button>
                </div>
                <Typography id="modal-modal-description" sx={{ mt: 1 }}>
                  <div className="newContainer">
                    <div>
                      <div className="designation-DetailsTbl-wrapper">
                        <table className="designation-DetailsTbl">
                          <thead>
                            <tr>
                              <th>Id</th>
                              <th>Name</th>
                              <th>Status</th>
                              <th>Date Joined</th>

                              <th>Investment Made</th>
                            </tr>
                          </thead>
                          <tbody>
                            {refferalData.length > 0 ? (
                              refferalData.map((report, index) => {
                                const d = new Date(report?.createdAt);
                                return (
                                  <tr key={index}>
                                    <td>{report.id}</td>
                                    <td>
                                      {report.firstname
                                        .charAt(0)
                                        .toUpperCase() +
                                        report.firstname.slice(1) +
                                        " " +
                                        report.lastname
                                          .charAt(0)
                                          .toUpperCase() +
                                        report.lastname.slice(1)}
                                    </td>
                                    <td>
                                      {report?.userStatus == 1 ? (
                                        <span className="verfiedStatus">
                                          Verified
                                        </span>
                                      ) : (
                                        <span className="unverifiedStatus">
                                          Unverified
                                        </span>
                                      )}
                                    </td>
                                    <td>{d.toDateString()}</td>

                                    <td>$ {report?.totalInvested}</td>
                                  </tr>
                                );
                              })
                            ) : (
                              <>
                                <div className="user-not-tittle">
                                  <h4 className="user-not-found">
                                    No data found
                                  </h4>
                                </div>
                              </>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </Typography>
              </Box>
            </Modal>
          </div>
        );
      },
    },
  ];

  const requestManagerColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/designation-report/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon
                  onClick={() => viewTeam(params?.row?.id)}
                />
              </div>
            </Link>
            <div className="designation-editButton">
              <button
                type="button"
                onClick={() => getRefferalList(params?.row?.id)}
              >
                <GroupsOutlinedIcon />
              </button>
            </div>
            <Modal
              open={open}
              onClose={() => setOpen(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className="designation-report-modal"
            >
              <Box className="modal-popup">
                <div className="modal-top text-right">
                  <Button className="closeBtn" onClick={() => setOpen(false)}>
                    <img src={Close} alt="close-icon" />
                  </Button>
                </div>
                <Typography id="modal-modal-description" sx={{ mt: 1 }}>
                  <div className="newContainer">
                    <div>
                      <div className="designation-DetailsTbl-wrapper">
                        <table className="designation-DetailsTbl">
                          <thead>
                            <tr>
                              <th>Id</th>
                              <th>Name</th>
                              <th>Status</th>
                              <th>Date Joined</th>
                              <th>Investment Made</th>
                            </tr>
                          </thead>
                          <tbody>
                            {refferalData.length > 0 ? (
                              refferalData.map((report, index) => {
                                const d = new Date(report?.createdAt);
                                return (
                                  <tr key={index}>
                                    <td>{report.id}</td>
                                    <td>
                                      {report.firstname
                                        .charAt(0)
                                        .toUpperCase() +
                                        report.firstname.slice(1) +
                                        " " +
                                        report.lastname
                                          .charAt(0)
                                          .toUpperCase() +
                                        report.lastname.slice(1)}
                                    </td>
                                    <td>
                                      {report?.userStatus == 1 ? (
                                        <span className="verfiedStatus">
                                          Verified
                                        </span>
                                      ) : (
                                        <span className="unverifiedStatus">
                                          Unverified
                                        </span>
                                      )}
                                    </td>
                                    <td>{d.toDateString()}</td>

                                    <td>$ {report?.totalInvested}</td>
                                  </tr>
                                );
                              })
                            ) : (
                              <h3>No data found</h3>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </Typography>
              </Box>
            </Modal>
          </div>
        );
      },
    },
  ];

  const viewTeam = (id) => {
    let token = localStorage.getItem("accessToken");
    setLoading(true);

    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "getFollowersByManagerId",
      headers: {
        "x-access-token": token,
      },
      data: {
        manager_id: id,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setPageState((old) => ({
          ...old,
          data: response.data.data,
          total: response.data.data.count,
        }));
        setReportDetailsLevel(response.data.data);
        // window.location.reload(true);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  const getRefferalList = (id) => {
    setOpen(true);
    setLoading(true);
    let token = localStorage.getItem("accessToken");
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "get-referral-user",
      headers: {
        "x-access-token": token,
      },
      data: {
        user_id: id,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setRefferalData(response.data.data);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  useEffect(() => {
    fetchFollowersDetails();
  }, []);
  const fetchFollowersDetails = () => {
    let token = localStorage.getItem("accessToken");
    setLoading(true);

    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "getFollowersByManagerId",
      headers: {
        "x-access-token": token,
      },
      data: {
        manager_id: params?.managerId,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setPageState((old) => ({
          ...old,
          data: response.data.data,
          total: response.data.data.count,
        }));
        setReportDetailsLevel(response.data.data);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <Loader isLoading={loading} />

        {pageState.data.length > 0 ? (
          <div className="datatable">
            <hr className="custom-divider"></hr>
            <div className="datatableTitle manageUser-top">
              <h5
                className="h5Title"
                style={{ textAlign: "left", marginBottom: "0" }}
              >
                Team - Reports to{" "}
                {pageState.data?.[0]?.managerFirstname.charAt(0).toUpperCase() +
                  pageState.data?.[0]?.managerFirstname.slice(1) +
                  " " +
                  pageState.data?.[0]?.managerLastname.charAt(0).toUpperCase() +
                  pageState.data?.[0]?.managerLastname.slice(1)}
              </h5>
            </div>
            <div className="designationReport-section">
              <h5 className="designationlevel-text">
                Level 2 Team Members - VPs
              </h5>

              <DataGrid
                className="datagrid"
                autoHeight
                rows={pageState.data.filter((item) => item.level == 2)}
                rowCount={pageState.total}
                rowsPerPageOptions={[10, 30, 50, 70, 100]}
                pagination
                columns={userColumns.concat(requestColumn)}
              />
              
 
            </div>
            <div className="designationReport-section">
              <h5 className="designationlevel-text">
                Level 3 Team Members - Regional Managers
              </h5>

             
              <DataGrid
                className="datagrid"
                autoHeight
                rows={pageState.data.filter((item) => item.level == 3)}
                rowCount={pageState.total}
                rowsPerPageOptions={[10, 30, 50, 70, 100]}
                pagination
                columns={userManagerColumns.concat(requestManagerColumn)}
              />
              
            </div>
            <div className="designationReport-section">
              <h5 className="designationlevel-text">
                Level 4 Team Members - Consultant
              </h5>

              <DataGrid
                className="datagrid"
                autoHeight
                rows={pageState.data.filter((item) => item.level == 4)}
                rowCount={pageState.total}
                rowsPerPageOptions={[10, 30, 50, 70, 100]}
                pagination
                columns={userConsultantColumns.concat(actionColumn)}
              />
  
            </div>
            <div className="designationReport-section">
              <h5 className="designationlevel-text">
                Level 5 Team Members - Referral
              </h5>

              <DataGrid
                className="datagrid"
                autoHeight
                rows={pageState.data.filter((item) => item.level == 5)}
                rowCount={pageState.total}
                rowsPerPageOptions={[10, 30, 50, 70, 100]}
                pagination
                columns={userConsultantColumns.concat(actionColumn)}
              />
  
            </div>
          </div>
        ) : (
          "No Data Found"
        )}
      </div>
    </div>
  );
};

export default DesignationReportDetails;
